export enum OpportunityDisplayEnum {
    Overview = 1,
    Completion = 2,
    Audit = 3
}